import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Viewer } from './pages/Viewer';
import { UseCases } from './pages/UseCases';
import { Credits } from './pages/Credits';
import './styles.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/viewer" element={<Viewer />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/credits" element={<Credits />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

